import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { claimAdminRole, getCurrentStaffRole } from "@/lib/admin-access";
import { AdminNav } from "@/components/AdminNav";

export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: async () => {
    let role = await getCurrentStaffRole();
    if (!role) {
      // Allowlisted staff signing in for the first time get their role here.
      const claimed = await claimAdminRole();
      if (claimed) role = "admin";
    }
    if (!role) {
      throw redirect({ to: "/admin", search: { denied: "1" } });
    }
    return { staffRole: role };
  },
  component: AdminShell,
});

function AdminShell() {
  const { staffRole } = Route.useRouteContext();
  return (
    <>
      <AdminNav role={staffRole} />
      <Outlet />
    </>
  );
}
